define('core/views/media/UploadsView',[
    'backbone',

    'core/views/media/UploadsProgressSubView',
    'core/views/media/UploadsRichSubView',

    'core/templates/postMediaUploads',
], function (
    Backbone,

    UploadsProgressSubView,
    UploadsRichSubView,

    postMediaUploadsTemplate
) {
    'use strict';

    // UploadsView acts as a container for the legacy and rich subviews.
    var UploadsView = Backbone.View.extend({
        initialize: function () {
            // Initialize subviews
            this.richView = new UploadsRichSubView();
            this.rich = this.richView.collection;

            this.uploadProgressView = new UploadsProgressSubView();
            this.uploadProgress = this.uploadProgressView.collection;

            // Watch models to expand / collapse textarea
            this.listenTo(this.rich, 'all', this._updateEmpty);
            this.listenTo(this.uploadProgress, 'all', this._updateEmpty);
        },

        render: function () {
            // Must detach subview before this.$el.html() or else
            // jQuery will undelegate all events on subview
            this.richView.$el.detach();
            this.uploadProgressView.$el.detach();

            this.$el.html(postMediaUploadsTemplate());

            this._updateEmpty();

            // Re-attach subview elements
            this.richView.setElement(this.$('[data-role=media-rich-list]')[0]);
            this.uploadProgressView.setElement(this.$('[data-role=media-progress-list]')[0]);

            return this;
        },

        clear: function () {
            this.rich.reset();
            this.uploadProgress.reset();
        },

        _updateEmpty: function () {
            if (!this.richView.hasVisible() && !this.uploadProgressView.hasVisible())
                this.$el.addClass('empty');
            else
                this.$el.removeClass('empty');
        },
    });

    return UploadsView;
});

